import CustomEventTarget from "../lib/CustomEventTarget";
import SendRequest from "../lib/ajaxPost";
import {
    each
} from '../lib/util';

const ALLOWED_FILTERS = ['adapterColor', 'adapterFootprint', 'adapterMounting', 'adapterStyle', 'beamType', 'beamWaist', 'bootColor',
    'brand', 'bufferTubeSize', 'cableExitType', 'cableStyle', 'category', 'cleaningFunction',
    'componentProductCategory', 'connectorType', 'documentCategory', 'endfaceType', 'ferruleSize', 'ferruleType',
    'fiberCladdingSize', 'fiberCount', 'fiberType', 'function', 'gender', 'heatShrinkColor', 'housingColor',
    'insertionExtraction', 'keyOrientation', 'numberOfCleans', 'operatingEnvironment', 'performance', 'plugPerformance', 'polishType',
    'springForce', 'standard', 'style', 'type', 'useType'];
const API_URL_BASE = '/umbraco/rhythm/productapi/filter';
export const PRODUCTS_PER_PAGE = 25;
export const PAGE_DEFAULT = 1;
export const ORDER_ASC = 'asc';
export const ORDER_DESC = 'desc';
export const ORDER_DEFAULT = ORDER_ASC;
export const SORT_ALLOWED = ['partNumber', 'name'];
export const SORT_ALLOWED_AEN = ['partNumber', 'name', 'documentCategory'];
const DEFAULT_FILTER_MODEL = {
    take: PRODUCTS_PER_PAGE,
    page: PAGE_DEFAULT,
    order: ORDER_DEFAULT,
    sort: SORT_ALLOWED[0],
    productCategory: '',
    primary1: '',
    primary2: '',
    primary3: ''
};
const DEFAULT_FILTER_MODEL_AEN = {
    take: PRODUCTS_PER_PAGE,
    page: PAGE_DEFAULT,
    order: ORDER_DEFAULT,
    sort: SORT_ALLOWED_AEN[0],
    productCategory: '',
    primary1: '',
    primary2: '',
    primary3: ''
};

let data;
let eventTarget;

export let filterModel;
export let dataSource = {};

function formatResponse(res) {
    return JSON.parse(res.text);
}

export function getFilters() {
    return Object.keys(filterModel)
        .filter(f => f.slice(0, 1) !== '_')
        .reduce((key, acc) => {
            acc[key] = filterModel[key];
            return acc;
        }, {})
}

export function updateFilterModel(name, value, action) {
    if (ALLOWED_FILTERS.indexOf(name) < 0) {
        return;
    }

    let valueArray = [];

    if (typeof filterModel[name] !== 'undefined') {
        valueArray = typeof filterModel[name] === 'object' ? filterModel[name] : [filterModel[name]];
    }

    if (action === 'remove') {
        const targetIndex = valueArray.indexOf(value);
        valueArray.splice(targetIndex, 1);
    } else if (action === 'set') {
        valueArray = [value];
    } else {
        valueArray.push(value);
    }

    // Update the model.
    filterModel[name] = valueArray;

    // Update the URL to reflect the model.
    updateUrlForFilterModel();

}

export function resetFilterModel() {

    // Reset the model.
    filterModel = {
        order: filterModel.order,
        page: 1,
        primary1: filterModel.primary1,
        primary2: filterModel.primary2,
        primary3: filterModel.primary3,
        productCategory: filterModel.productCategory,
        sort: filterModel.sort,
        take: filterModel.take
    };

    // Update the URL to reflect the model.
    updateUrlForFilterModel();

}

export function getProducts() {
    dataSource = new Promise((resolve, reject) => {
        new SendRequest(`${API_URL_BASE}`, filterModel)
            .then(res => {
                data = formatResponse(res);
                resolve(data);
            })
            .catch(err => {
                console.error(err);
                reject(err);
            })
    });

    const event = new CustomEvent('data:request');
    eventTarget.dispatchEvent(event);
}

export function addProductListener(cb) {

    eventTarget.addEventListener('data:request', () => {
        dataSource.then((data) => {
            cb(data)
        });
    });

    dataSource.then((data) => {
        cb(data)
    });
}

export default function initProductService(initialModel, listingType) {
    let isCommon = listingType === 'Common',
        isAen = listingType === 'Specialized - Application Engineering Notes',
        defaultFilter = isCommon
            ? DEFAULT_FILTER_MODEL :
            (isAen
                ? DEFAULT_FILTER_MODEL_AEN
                : null);
    const queryParams = new URLSearchParams(window.location.search);
    filterModel = ALLOWED_FILTERS.reduce((acc, filterName) => {
        const values = queryParams.getAll(filterName);
        if (values && values.length) {

            // Add the values to the array.
            let array = acc[filterName] || [];
            array = array.concat(values);

            // Remove duplicates.
            array = array.filter((x, i) => array.indexOf(x) === i);

            // Update the array using the filter name.
            acc[filterName] = array;

        }
        return acc;
    }, Object.assign(JSON.parse(JSON.stringify(defaultFilter)), initialModel));
    let urlOrder = queryParams.get('order'),
        urlSort = queryParams.get('sort'),
        urlPage = queryParams.get('page');
    if (urlOrder) {
        filterModel.order = urlOrder;
    }
    if (urlSort) {
        filterModel.sort = urlSort;
    }
    if (urlPage) {
        filterModel.page = parseInt(urlPage, 10);
    }

    eventTarget = new CustomEventTarget();

    getProducts();

}

/**
 * Updates the URL so that it contains the keys/values in the filter model.
 */
export function updateUrlForFilterModel() {

    // Variables.
    let values, newUrl,
        queryParams = new URLSearchParams(),
        keys = Object.keys(filterModel),
        ignoreStaticKeys = ['primary1', 'primary2', 'primary3', 'take', 'productCategory'],
        defaultsToIgnore = [
            {
                key: 'page',
                value: PAGE_DEFAULT
            }, {
                key: 'order',
                value: ORDER_ASC
            }, {
                key: 'sort',
                value: SORT_ALLOWED[0]
            }
        ];

    // Process each key in the filter model.
    each(keys, x => {
        if (ignoreStaticKeys.indexOf(x) >= 0) {
            return;
        }
        values = filterModel[x];
        if (!Array.isArray(values)) {
            values = [values];
        }
        if (defaultsToIgnore.some(y => y.key === x && y.value === values[0])) {
            return;
        }
        each(values, y => {
            queryParams.set(x, y);
        });
    });

    // Get the URL based on the new query string.
    let strQuery = queryParams.toString();
    let separator = strQuery.length > 0 ? '?' : '';
    newUrl = window.location.pathname + separator + queryParams.toString();

    // Update the state.
    history.replaceState(filterModel, document.title, newUrl);

}
